import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import "../../assets/css/modal.css";
import "./LoginDivOnly.css";
import axios from "axios";
import { baseUrl, portal, dataContext } from "../../App";
import activityLogSubmission from "../../helper/activitylog";
import { useNavigate, useSearchParams } from "react-router-dom";
import analyticEvent from "../../helper/gaEvent";

const LoginDivOnlyDaily = ({
  activeBottom,
  setActiveBottom,
  setShowOtpModal,
  showOtpModal
}) => {
  const { token, setToken, playerData, setPlayerData } =
    useContext(dataContext);
  const [mobileNumber, setMobileNumber] = useState("");
  const [showErrorOutline, setShowErrorOutline] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showLoginModalCampaign, setShowLoginModalCampaign] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();

  let navigate = useNavigate();
  useEffect(() => {
    analyticEvent('login', 'login-view')
  }, [])
  if (activeBottom === "campaign") {
    localStorage.setItem("AuthToken", "");
  }
  function checkMobileNumber() {
    var mobilePattern = /^(?:\+88|88)?(01[3-9]\d{8})$/;
    if (mobileNumber.match(mobilePattern)) {
      return true;
    } else {
      return false;
    }
  }
  function loginOperation() {
    if (checkMobileNumber()) {
      setIsLoading(true);
      axios
        .post(`${baseUrl}/api/login/`, {
          msisdn: mobileNumber.toString().slice(-10),
          portal: portal,
          qcid: sessionStorage.getItem("cid")
        })
        .then((response) => {
          // console.log(response.data.token);
          let newToken = response.data.token;
          localStorage.setItem("AuthToken", newToken);
          localStorage.setItem("user_msisdn", mobileNumber.toString().slice(-10));
          setToken(newToken);
          analyticEvent('login', 'login-success')
          if (activeBottom === "campaign") {
            if(response.data?.isSubscribe){
              navigate("../");
            }else{
              activityLogSubmission(
                "login_submit",
                mobileNumber.toString().slice(-10)
              );
              {
              // navigate("../");
              const paramsObject = {};

              for (const [key, value] of searchParams) {
                paramsObject[key] = value;
              }
              
              console.log(paramsObject);
              const config = {
                headers: { Authorization: `Token ${newToken}` },
              };
              axios
              .post(
                `${baseUrl}/subscription/create/`,
                { portal: portal, qcid: sessionStorage.getItem("cid"), "service_type": "Daily", ...paramsObject },
                config
              )
              .then((response) => {
                let data = response.data;
                setIsLoading(false);
                console.log(data);
                if (data?.redirectURL) {
                  console.log(`${data?.redirectURL}`);
                  window.location.replace(`${data?.redirectURL}`);
                }
              });}
            }
          }else{
            setIsLoading(false);
          }
        });
    } else {
      console.log("error");
      setShowErrorOutline(true);
      analyticEvent('login', 'login-error')
    }
  }

  return (
    <>
      <div
className="fixedDivLogin"
      >
        <Modal.Header>
          <Modal.Title>আপনার মোবাইল নম্বর দিন</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className={`inputSpan ${showErrorOutline && "errorOutline"}`}>
            +88{" "}
            <input
              type="tel"
              maxLength={11}
              onKeyUp={(e) => {
                setMobileNumber(e.target.value);
                setShowErrorOutline(false);
              }}
              onKeyDown={(e) => e.key === 'Enter' && loginOperation()}
              id="mobileNumber"
              name="mobileNumber"
              placeholder="মোবাইল নম্বর"
              className="inputFieldMobile"
            />{" "}
          </span>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn numberSubmit"
            onClick={loginOperation}
          >
            {isLoading ? (
              <Spinner animation="border" variant="light" size="sm" />
            ) : (
              "প্রবেশ করুন"
            )}
          </button>
        </Modal.Footer>
      </div>
    </>
  );
};

export default LoginDivOnlyDaily;
